function initContestWorkFormatsSettings() {
  const storageUpgradeButtons = document.querySelectorAll('.storage-upgrade-button');

  storageUpgradeButtons?.forEach(function (storageUpgradeButton) {
    storageUpgradeButton.addEventListener('click', async function () {
      const modalSelector = '#paid-settings-modal[data-event-source-id="contest-storage-upgrade"]';
      const paidSettingsModal = document.querySelector(modalSelector);

      if (!paidSettingsModal) {
        return false;
      }

      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');
    });
  });

  const certificateRoot = document.querySelector('#attach-certificate-file');
  if (!certificateRoot) {
    return;
  }

  const certificateInput = certificateRoot.querySelector('.js-certificate-upload-input');
  const fileNameEl = certificateRoot.querySelector('#certificate-file-name');
  const fileNameWrap = certificateRoot.querySelector('#certificate-file-name-wrap');
  const awardDelete = certificateRoot.querySelector('.js-certificate-delete');
  const deleteForm = document.querySelector('.js-certificate-delete-form');
  const certificateForm = certificateRoot.querySelector('.js-certificate-upload-form');

  if (certificateInput && fileNameEl) {
    certificateInput.addEventListener('change', () => {
      if (certificateInput.files && certificateInput.files.length > 0) {
        fileNameEl.textContent = certificateInput.files[0].name;
        fileNameWrap?.classList.remove('hidden');
      }
    });
  }

  if (awardDelete && deleteForm) {
    awardDelete.addEventListener('click', () => {
      if (!window.confirm('Удалить сертификат участника?')) {
        return;
      }

      deleteForm.submit();
    });
  }

  if (certificateForm && certificateInput) {
    certificateForm.addEventListener('submit', (event) => {
      if (!certificateInput.files || certificateInput.files.length === 0) {
        event.preventDefault();
        window.alert('Выберите PDF-файл сертификата перед отправкой');
      }
    });
  }
}

export { initContestWorkFormatsSettings };
